import { render, staticRenderFns } from "./orderlist.vue?vue&type=template&id=75c8df7c&scoped=true"
import script from "./orderlist.vue?vue&type=script&lang=js"
export * from "./orderlist.vue?vue&type=script&lang=js"
import style0 from "./orderlist.vue?vue&type=style&index=0&id=75c8df7c&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c8df7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\certbuyliantuo\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75c8df7c')) {
      api.createRecord('75c8df7c', component.options)
    } else {
      api.reload('75c8df7c', component.options)
    }
    module.hot.accept("./orderlist.vue?vue&type=template&id=75c8df7c&scoped=true", function () {
      api.rerender('75c8df7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/orderlist.vue"
export default component.exports